import Pointer from '../../../Components/Pointer';
import { Element, Events, scroller } from 'react-scroll'
import {useDispatch, useSelector} from "react-redux";
import { setFavouritesIsActive } from "../../../../Features/Misc/navBarSlice"
import { Animate } from "react-simple-animate";
import BackButton from "../../../Components/BackButton";
import FaveHeart from "../../../Components/FaveHeart";
import {activeMediaReset} from "../../../../Features/Misc/activeSlice";
import stripHtml from "../../../Components/StripHTML";



export default function FaveReadOffCanvas(props) {

    const dispatch = useDispatch()

    const { activeRead } = useSelector((state) => state.active)
    const { authorName, imgSrc, text, title, date, mediaType, mediaId} = activeRead && activeRead

    const displayName = authorName ? (authorName === 'wesley@hydra' ? 'Sleep Geek' : authorName) : 'Sleep Geek';

    const mediaData = {
        mediaType,
        mediaId
    }


    const scrollToDivInside = () =>{



        let goToContainer = new Promise((resolve, reject) => {

            Events.scrollEvent.register('end', () => {
                resolve();
                Events.scrollEvent.remove('end');
            });

            scroller.scrollTo('scroll-container', {
                duration: 500,
                delay: 0,
                smooth: 'easeInOutQuart'
            });

        });

        goToContainer.then(() =>
            scroller.scrollTo('scroll-container-second-element', {
                duration: 500,
                delay: 0,
                smooth: 'easeInOutQuart',
                containerId: 'scroll-container'
            }));
    }


//truncate needed
    return (

        <div className={`FaveReadOffCanvas flex flex-col justify-start `}>
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem" }} duration={0.7} >
            <BackButton customStyles={false} func={() => { dispatch(setFavouritesIsActive()); dispatch(activeMediaReset()) } } />

            <div className=" read h-172 pr-12 pt-2 overflow-y-scroll  bg-purple-dashboard scroll-container text-black " id="scroll-container">

                <div className="FaveReadOffCanvas__titleBar flex flex-row justify-between p-2 ">
                    <div className={`text-white text-xl`}>{stripHtml(title)}</div>
                    <FaveHeart mediaId={mediaId} mediaType={mediaType} type={"Read_offCanvas"} />
                </div>


                    <Element className=" read-inner bg-white w-full h-auto flex flex-col  rounded-lg px-4 py-8 gap-4 " name={"scroll-container-second-element"}>

                        <Element className="scroll-container-second-element read-inner-img w-full  h-96 min-h-96 rounded-lg bg-cover no-repeat bg-center "
                                 style={{backgroundImage: `url(${imgSrc})` }}
                        >

                        </Element>

                        <div className="read-inner-details flex flex-row justify-between w-full">

                            <div className="read-inner-details-left flex flex-row gap-4 h-24 items-center w-full px-4">
                                <div className="read-inner-details-left-avatar min-w-12 min-h-12 h-12 rounded-full bg-cover no-repeat bg-center "
                                     style={{backgroundImage: `url(https://www.pexels.com/photo/man-smiling-behind-wall-220453/)` }}>
                                </div>
                                <div className="read-inner-details-left-author">
                                    By {displayName}
                                </div>
                            </div>

                            <div className="read-inner-details-right flex flex-row gap-4 items-center w-full justify-end px-4">
                                <div className="read-inner-details-right-category">Category: sleep</div>
                                <div className="read-inner-details-right-date">{date.substring(0,10)}</div>
                                <FaveHeart customStyles={` text-3xl text-dark-pink `} type={"Read_offCanvas"} mediaId={mediaId} mediaType={mediaType} />
                            </div>

                        </div>



                        <div dangerouslySetInnerHTML={{__html: text}} className='read-inner-content p-4'>

                        </div>


                        <div  className="pointer-div flex flex-row items-center justify-center">
                            <Pointer direction="up" task={scrollToDivInside} bgColor={"purple-dashboard"}  />
                        </div>


                    </Element>

            </div>
            </Animate>
        </div>

    );
}
